class ContactRoleDefaultCtrl {
    constructor($filter) {
        this._translateRole = name => $filter('translate')(`gateway.contacts.common.views.roles.${name}`);
    }

    $onInit() {
        const subtype = (this.roleType === 'account') ? this.roleModel.subtype : this.roleModel.accountContactRole.subtype;
        this.roleName = this._translateRole(subtype.value.name);
    }
}
ContactRoleDefaultCtrl.$inject = ['$filter'];
export default ContactRoleDefaultCtrl;
